import { ExtraMarkers } from "leaflet";
import { Marker, useMap } from "react-leaflet";
import React, { useEffect, useState } from "react";
import Point from "models/geospatial/point";
import ExtraContent from "../extra-content";

const PointLeaflet = ({ point }: { point: Point }) => {
  const map = useMap();
  const [marker, setMarker] = useState<ExtraMarkers.Icon>(
    ExtraMarkers.icon({
      markerColor: "blue-dark",
      shape: "circle",
      prefix: "i",
      icon: "",
    }),
  );
  useEffect(() => {
    if (point?.styling) {
      setMarker(
        ExtraMarkers.icon({
          markerColor: point?.styling?.markerColor ?? "blue-dark",
          shape: point?.styling?.shape ?? "circle",
          prefix: point?.styling?.prefix ?? "i",
          icon: point?.styling?.icon ?? "",
        }),
      );
    }
    if (point.latitude && point.longitude) {
      map.setView([+point.latitude, +point.longitude]);
    }
  }, [point]);
  return (
    <Marker
      key={`point-${point.guid}`}
      icon={marker}
      position={[+point.latitude, +point.longitude]}
    >
      <ExtraContent info={{ ...point }} />
    </Marker>
  );
};

export default PointLeaflet;
